import React, { useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { UserContext } from "UserContext";
import { EmailListSubscriptionRequestModal } from "EmailListSubscriptionRequestModal";
import { CompanyConnectionRequestModal } from "CompanyConnectionRequestModal";
import axios from "axios";
import { Modal } from "react-bootstrap";

const ConnectSubscribeButtonGroup = ({
  company,
  respectSubscribeInUrl = false,
  buttonClassName = "btn ps-btn--primary",
}) => {
  const [userContext, dispatchUserContext] = useContext(UserContext);

  const [userIsConnected, setUserIsConnected] = useState(false);
  const [userHasRequested, setUserHasRequested] = useState(false);

  useEffect(() => {
    const getUserInfo = async () => {
      if (company.name && userContext.user) {
        let result;
        try {
          result = await axios.get(
            "/api/v2/companies/" +
              company.company_id +
              "/users/" +
              userContext.user.user_id +
              "/connection_requests"
          );
        } catch (err) {
          console.log(err);
        }

        let connectionRequests = result.data;
        if (connectionRequests.length) {
          if (connectionRequests[0].active) {
            setUserIsConnected(true);
          } else {
            setUserHasRequested(true);
          }
        } else {
          setUserIsConnected(false);
        }
      }
    };
    getUserInfo();
  }, [userContext.user, company.company_id]);

  const NoActionButton = (props) => {
    return (
      <button
        className={buttonClassName}
        style={{
          maxWidth: "unset",
          cursor: "default",
          pointerEvents: "none",
          backgroundColor: "#CCE8FF",
          color: "#0695FC!important",
        }}
        id={`track-target-${company.company_id}`}
      >
        {props.label}
      </button>
    );
  };

  const RequestButton = (props) => {
    return (
      <button
        className={buttonClassName}
        id={`track-target-${company.project_id}`}
        style={{
          maxWidth: "unset",
        }}
        onClick={() => {
          setShowModal(true);

          try {
            let eventProperties = {
              companyName: company.name,
              companyID: company.project_id,
            };
            PSBase.analytics.logAmplitudeEvent(
              "company engagement: clicked connect/subscribe",
              eventProperties
            );
          } catch (err) {
            console.error(err);
          }

          if (respectSubscribeInUrl && typeof window !== "undefined") {
            urlArray = window.location.href.split("/");
            isSubscribeInPath = urlArray[urlArray.length - 1] === "subscribe";

            if (!isSubscribeInPath && !userContext.user) {
              let path = window.location.href;
              if (path[path.length - 1] != "/") {
                path = path + "/";
              }
              history.replaceState(null, null, path + "subscribe/");
            }
          }
        }}
      >
        {props.label}
      </button>
    );
  };

  let urlArray;
  let isSubscribeInPath = false;

  if (respectSubscribeInUrl) {
    urlArray = window.location.href.split("/");
    isSubscribeInPath = urlArray.includes("subscribe");
    if (isSubscribeInPath) {
      if (window.location.href[window.location.href.length - 1] != "/") {
        history.replaceState(null, null, window.location.href + "/");
      }
    }
  }

  let [showModal, setShowModal] = useState(isSubscribeInPath);

  let handleClose = (didSendRequest) => {
    setShowModal(false);
    if (didSendRequest) {
      setUserHasRequested(true);
    }

    if (respectSubscribeInUrl) {
      urlArray = window.location.href.split("/");
      isSubscribeInPath = urlArray.includes("subscribe");

      if (isSubscribeInPath) {
        history.replaceState(
          null,
          null,
          window.location.href.replace("subscribe/", "")
        );
      }
    }
  };

  return (
    <React.Fragment>
      {userContext.user && userContext.user.user_id && userIsConnected && (
        <NoActionButton label={"Connected"} />
      )}

      {userContext.user &&
        userContext.user.user_id &&
        userHasRequested &&
        !userIsConnected && <NoActionButton label={"Request sent"} />}

      {userContext.user &&
        userContext.user.user_id &&
        !userIsConnected &&
        !userHasRequested && <RequestButton label={"Connect"} />}

      {!userContext.user && !userHasRequested && (
        <RequestButton label={"Subscribe"} />
      )}
      {!userContext.user && userHasRequested && (
        <NoActionButton label={"Request sent"} />
      )}

      {userContext.user && userContext.user.user_id && !isSubscribeInPath && (
        <CompanyConnectionRequestModal
          userId={userContext.user.user_id}
          show={showModal}
          handleClose={handleClose}
          company={company}
        />
      )}
      {(!userContext.user || isSubscribeInPath) && (
        <EmailListSubscriptionRequestModal
          show={showModal}
          handleClose={handleClose}
          company={company}
        />
      )}
    </React.Fragment>
  );
};

ConnectSubscribeButtonGroup.propTypes = {};

export default ConnectSubscribeButtonGroup;
